import CityLandingPage from './page';

const natalData = {
  cityName: 'Natal',
  state: 'RN',
  slug: 'palestra-silenciosa-natal',
  coordinates: {
    lat: -5.7945,
    lng: -35.2110,
  },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa natal',
    'silent conference natal rn',
    'aluguel fones sem fio natal',
    'eventos corporativos natal',
    'tradução simultânea natal',
    'festa silenciosa natal',
  ],
  heroTitle: 'palestra silenciosa natal',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos, conferências multilíngues e workshops em Natal. Transforme seu evento com nossa solução inovadora de palestra silenciosa.',
  localStats: {
    clients: '60+',
    satisfaction: '98%',
  },
  localTestimonials: [],
  localFAQs: [
    {
      question: 'Vocês atendem toda a região metropolitana de Natal?',
      answer: 'Sim! Atendemos toda a Grande Natal, incluindo Parnamirim, São Gonçalo do Amarante, Macaíba, Extremoz e todo o litoral potiguar. Nossa equipe está estrategicamente posicionada para atender rapidamente qualquer localidade.',
    },
    {
      question: 'Qual o prazo de antecedência para contratar em Natal?',
      answer: 'Recomendamos reservar com pelo menos 2 semanas de antecedência para eventos em Natal. Durante a alta temporada de turismo (dezembro a março), sugerimos 1 mês. Consulte-nos para demandas urgentes conforme disponibilidade.',
    },
    {
      question: 'Vocês oferecem suporte técnico durante eventos em Natal?',
      answer: 'Com certeza! Todos os nossos pacotes em Natal incluem técnico especializado presente durante todo o evento. Garantimos funcionamento perfeito do início ao fim, com suporte imediato para qualquer eventualidade.',
    },
    {
      question: 'Quantos fones sem fio vocês disponibilizam para eventos em Natal?',
      answer: 'Nosso estoque atende desde eventos intimistas (30 fones) até grandes congressos em Natal (250+ fones). Trabalhamos com equipamentos de última geração e sempre mantemos unidades de backup para segurança total.',
    },
    {
      question: 'A palestra silenciosa funciona em locais abertos em Natal, como na Via Costeira?',
      answer: 'Sim! Nossos equipamentos têm alcance de até 100 metros sem obstáculos e funcionam perfeitamente em ambientes abertos de Natal, incluindo eventos na Via Costeira, Ponta Negra e resorts à beira-mar. Ideal para eventos ao ar livre com a brisa do litoral potiguar!',
    },
  ],
  seoTitle: 'Natal Palestra Silenciosa | Aluguel Fones Sem Fio RN | STIB',
  seoDescription: 'Palestra silenciosa Natal: aluguel de fones sem fio para eventos corporativos, conferências e workshops no Rio Grande do Norte. Tecnologia premium com equipe enviada de São Paulo. Solicite orçamento!',
};

export default function NatalLandingPage() {
  return <CityLandingPage cityData={natalData} />;
}